<template>
  <app-dropdown
    class="date-picker"
    :data-title="dateFormatted"
    :data-menu-width="menuWidth"
    no-border
    no-control
    @hidden="setMenu(false)"
    @opened="setMenu(true)"
  >
    <v-date-picker
      v-model="val"
      :disabled="disabled"
      :color="getColor(palette.primary)"
      locale="pt-br"
      no-title
      @input="menu = false"
    ></v-date-picker>
  </app-dropdown>
</template>

<script>
import AppDropdown from "@components/Dropdown";
import provider from "@mixins/provider";
import colors from "@mixins/colors";

export default {
  components: {
    AppDropdown,
  },

  data() {
    return {
      menu: false,
    };
  },

  props: {
    readonly: {
      type: Boolean,
      default: false,
    },

    value: {},

    menuWidth: {
      type: String,
      default: "auto",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  mixins: [provider, colors],

  computed: {
    dateFormatted() {
      return this.formatDate(this.val);
    },

    val: {
      get() {
        return this.value;
      },

      set(value) {
        if (!this.readonly) this.$emit("input", value);
      },
    },
  },

  methods: {
    formatDate(date) {
      if (!date) return "-";

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    setMenu(val) {
      this.menu = val;
    },
  },

  watch: {
    menu(value) {
      if (value && this.readonly) this.$nextTick(() => (this.menu = false));
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.date-picker {
  background: none;

  ::v-deep .dropdown-menu {
    border: none;
    background: transparent;
  }
}
</style>
